<template>
  <ToggleGroupRoot
    v-model="internalState"
    :type="type"
    :aria-label="ariaLabel"
    asChild
  >
    <ScrollableList>
      <template #items>
        <User
          as="div"
          v-for="user in users"
          :key="user.id"
          :user="user"
          :isChecked="isChecked(user.id)"
          :showCheckbox="type === 'multiple'"
        />
      </template>
    </ScrollableList>
  </ToggleGroupRoot>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import { ToggleGroupRoot } from "radix-vue";
import { ScrollableList } from "@/Components/List";
import { User } from "@/Components/Users";

const emit = defineEmits(["update:selected"]);

const props = defineProps({
  users: { type: Array, default: () => [] },
  selected: { type: [String, Array], required: false },
  type: {
    type: String,
    validator: (val) => ["single", "multiple"].includes(val),
    required: true,
  },
  ariaLabel: { type: String, default: "Users" },
});

const internalState = ref(props.selected);

watchEffect(() => {
  emit("update:selected", internalState.value);
});

function isChecked(userId) {
  if (props.type === "single") {
    return internalState.value === userId;
  }
  return internalState.value.includes(userId);
}
</script>
